import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Observable} from "rxjs";
import {Arquivo} from "../../../domain/Arquivo";
import {Directory, Filesystem, ReadFileResult} from "@capacitor/filesystem";

@Injectable()
export class ArquivoHttpService extends AbstractHttpService<Arquivo>{
    url = '/api/arquivo';

    sendOld(arquivo: Arquivo): Observable<string>{
      return this.http.post(this.urlBase, arquivo, {responseType:"text"})
    }

  send(arquivo: Arquivo, blobl: Blob): Observable<string>{
    let url = `${this.urlBase}/${arquivo.id}/${arquivo.nome}/`
    if(arquivo.projeto)
      url += "projeto/"+arquivo.projeto.id
    else
      url += "especime/"+arquivo.especime.id
    return this.http.post(url, blobl , {responseType:"text"})
  }


  private dataURItoBlob(base64: string) {
    // write the bytes of the string to an ArrayBuffer
    var ab = new ArrayBuffer(base64.length);

    // create a view into the buffer
    var ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (var i = 0; i < base64.length; i++) {
      ia[i] = base64.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    return new Blob([ab], {type: 'image/jpg'});

  }
}
